<template>
    <section class="step">
        <div class="title">换新流程 <span>STEP</span></div>
        <div class="stepBg">
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.step{margin: 20px auto;}
.title{border-bottom:solid #efefef 1px;padding: 10px 0;font-size: 20px;color: #f9415d}
.title::before{content: "";display: inline-block;width: 12px;height: 12px;border:solid #f9415d 2px;margin-right: 10px;rotate: 10px;transform:rotate(45deg)}
.title span{color: #ccc;}
.stepBg{background: url(../../../assets/image/stepBg.png) center center no-repeat;background-size:1000px 450px;width: 1000px;height: 450px;margin:40px auto}
</style>
